// extracted by mini-css-extract-plugin
export default {"container":"IconMenu_container__Sky42"};